import { PayloadAction } from "@reduxjs/toolkit";
import { put, all, takeLatest, call } from "redux-saga/effects";
import Country from "models/Country";
import { LOAD_COUNTRY, LOAD_COUNTRY_SUCCESS } from "slices/maps.slice";
import { SET_ERROR } from "slices/globalError.slice";
import countryService from "services/countryService";

function* getCountryForModal({ payload }: PayloadAction<number[]>) {
  try {
    const modalCountry: Country = yield call(
      countryService.getBriefDisplay,
      payload,
    );
    yield put(LOAD_COUNTRY_SUCCESS(modalCountry?.[0]));
  } catch (ex: any) {
    put(SET_ERROR(ex));
  }
}

export default function* mapsErrorSaga() {
  yield all([takeLatest(LOAD_COUNTRY, getCountryForModal)]);
}
